export default function parseJson(responseText) {
  try {
    return JSON.parse(responseText);
  } catch (e) {
    return responseText;
  }
}
//# sourceMappingURL=parseJson.js.map